import {React, useEffect} from 'react';
import { useSelector } from 'react-redux';
import WOW from 'wowjs';
import translate from '../translate';

function Cards() {
    const language = useSelector(state => state.view.selectedLanguage);
    const componentName = 'cards';

    useEffect(() => {
        const wow = new WOW.WOW({
            live: false,
            offset: 100,
            mobile: true,
        });
        wow.init();
    }, []);

    return (
        <div className="card-section theme-light-bg pt-130">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card-wrapper d-flex justify-content-between align-items-center">
                            <div className="card-box wow fadeInUp" data-wow-delay="00ms" data-wow-duration="800ms">
                                <div className="icon">
                                    <img src="assets/img/icons/card-icon-1.png" alt=""/>
                                </div>
                                <div className="content">
                                    <h4 className="title">{translate(componentName, 'card1', language)}</h4>
                                </div>
                                <div className="dots">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                            <div className="card-box card-box__2 wow fadeInUp" data-wow-delay="200ms" data-wow-duration="800ms">
                                <div className="icon">
                                    <img src="assets/img/icons/card-icon-2.png" alt=""/>
                                </div>
                                <div className="content">
                                    <h4 className="title">{translate(componentName, 'card2', language)}</h4>
                                </div>
                                <div className="dots">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                            <div className="card-box card-box__3 wow fadeInUp" data-wow-delay="500ms" data-wow-duration="800ms">
                                <div className="icon">
                                    <img src="assets/img/icons/card-icon-3.png" alt=""/>
                                </div>
                                <div className="content">
                                    <h4 className="title">{translate(componentName, 'card3', language)}</h4>
                                </div>
                                <div className="dots">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Cards;